var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SentimentGauge',_vm._b({attrs:{"title":_vm.title,"item-id":_vm.itemId,"owner-posts":true}},'SentimentGauge',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }